export enum VerifiedBadgeType {
  VERIFIED = 'verified.svg',
  PARTIALLY_VERIFIED = 'partially-verified-v2.svg',
}
